import { useTable } from 'context/table-context'
import {
  Children,
  HTMLAttributes,
  RefObject,
  forwardRef,
  isValidElement,
  useEffect,
  useMemo,
} from 'react'

interface Props extends HTMLAttributes<HTMLTableSectionElement> {}

export const TableBody = forwardRef(
  ({ children, ...props }: Props, ref: RefObject<HTMLTableSectionElement>) => {
    const { setIsEmpty } = useTable()

    const hasChildren = useMemo(
      () =>
        Boolean(
          Children.toArray(children).filter((child) => isValidElement(child))
            .length,
        ),
      [children],
    )

    useEffect(() => {
      setIsEmpty(!hasChildren)
    }, [hasChildren])

    return !hasChildren ? null : (
      <tbody {...props} ref={ref}>
        {children}
      </tbody>
    )
  },
)
